import { AnnouncementMessages, TranslationAnnouncementMessages } from "../interfaces/announcementMessages";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationAnnouncementMessages = {
  [AnnouncementMessages.menuTitle]: "Notifications",
  [AnnouncementMessages.bellTooltip]: "Notifications",
  [AnnouncementMessages.dropdownTitle]: "NOTIFICATIONS",
  [AnnouncementMessages.markAllRead]: "Mark all as read",
  [AnnouncementMessages.viewAll]: "View all notifications",
  [AnnouncementMessages.emptyTitle]: "No notifications here",
  [AnnouncementMessages.emptySubtitle]: "Notifications and news show up here.",
  [AnnouncementMessages.defaultCta]: "Click here",
  [AnnouncementMessages.bannerHighlight]: "FEATURED",
  [AnnouncementMessages.bannerDismiss]: "Close",
  [AnnouncementMessages.pageTitle]: "Notifications",
  [AnnouncementMessages.pageSubtitle]: "Notifications shown in the bell to every user, within the defined period.",
  [AnnouncementMessages.newButton]: "New notification",
  [AnnouncementMessages.manageAccess]: "Manage access",
  [AnnouncementMessages.searchPlaceholder]: "Search by title",
  [AnnouncementMessages.loadError]: "Failed to load notifications, try again.",
  [AnnouncementMessages.retry]: "Try again",
  [AnnouncementMessages.listEmpty]: "No notifications registered yet.",
  [AnnouncementMessages.listTruncated]: "Showing {{shown}} of {{total}} notifications.",
  [AnnouncementMessages.tableTitle]: "Title",
  [AnnouncementMessages.tablePeriod]: "Period",
  [AnnouncementMessages.tableStatus]: "Status",
  [AnnouncementMessages.tableReads]: "Reads",
  [AnnouncementMessages.tableClicks]: "Clicks",
  [AnnouncementMessages.tableActions]: "Actions",
  [AnnouncementMessages.statusActive]: "Active",
  [AnnouncementMessages.statusScheduled]: "Scheduled",
  [AnnouncementMessages.statusExpired]: "Expired",
  [AnnouncementMessages.byAuthor]: "by {{name}}",
  [AnnouncementMessages.reachEveryone]: "All customers",
  [AnnouncementMessages.reachTenantOne]: "1 customer",
  [AnnouncementMessages.reachTenantMany]: "{{count}} customers",
  [AnnouncementMessages.reachUserOne]: "1 person",
  [AnnouncementMessages.reachUserMany]: "{{count}} people",
  [AnnouncementMessages.clicksHint]: "The read and click counters open the list of who received the notification.",
  [AnnouncementMessages.formTitleNew]: "New notification",
  [AnnouncementMessages.formTitleEdit]: "Edit notification",
  [AnnouncementMessages.formSubtitle]: "Visible to every user within the defined period.",
  [AnnouncementMessages.fieldTitle]: "Title",
  [AnnouncementMessages.fieldMessage]: "Message",
  [AnnouncementMessages.fieldLink]: "Link",
  [AnnouncementMessages.fieldLinkLabel]: "Button text",
  [AnnouncementMessages.fieldStartDate]: "Start",
  [AnnouncementMessages.fieldEndDate]: "End",
  [AnnouncementMessages.fieldHighlight]: "Highlight on the Launcher (banner)",
  [AnnouncementMessages.fieldAudience]: "Who receives it",
  [AnnouncementMessages.audienceEveryone]: "All customers",
  [AnnouncementMessages.audienceTargeted]: "Choose who receives it",
  [AnnouncementMessages.audienceEveryoneHint]: "Everyone in the suite sees it, across every customer.",
  [AnnouncementMessages.audienceTargetedHint]: "Only the customers and people you pick below.",
  [AnnouncementMessages.audienceSummaryLabel]: "Goes to",
  [AnnouncementMessages.audienceSummaryEmpty]: "Pick at least one customer or one person.",
  [AnnouncementMessages.targetTenantsHint]: "Everyone in these customers receives it.",
  [AnnouncementMessages.fieldTargetTenants]: "Customers",
  [AnnouncementMessages.fieldTargetUsers]: "People",
  [AnnouncementMessages.targetUsersHint]: "Search by name or email. The person receives it even if their customer is not on the list.",
  [AnnouncementMessages.audienceRequired]: "Pick at least one customer or person",
  [AnnouncementMessages.recipientSearching]: "Searching...",
  [AnnouncementMessages.recipientNoResults]: "Nobody found",
  [AnnouncementMessages.linkHelper]: "Optional — with a link, the notification button uses this text (default: \"Click here\")",
  [AnnouncementMessages.endAfterStart]: "End must be after start",
  [AnnouncementMessages.confirmDeleteTitle]: "Delete notification",
  [AnnouncementMessages.confirmDeleteMessage]: "The notification disappears from every user's bell and banner. Continue?",
  [AnnouncementMessages.interactionsTitle]: "Notification interactions",
  [AnnouncementMessages.interactionsEmpty]: "No interactions recorded yet.",
  [AnnouncementMessages.interactionsUser]: "User",
  [AnnouncementMessages.interactionsTenant]: "Tenant",
  [AnnouncementMessages.interactionsReadAt]: "Read at",
  [AnnouncementMessages.interactionsClickedAt]: "Clicked at",
  [AnnouncementMessages.interactionsEmail]: "Email",
  [AnnouncementMessages.interactionsCount]: "Total: {{count}}",
  [AnnouncementMessages.interactionsExport]: "Export CSV",
  [AnnouncementMessages.interactionsExportPartial]: "Exported {{exported}} of {{total}} rows. The file is incomplete.",
  [AnnouncementMessages.interactionsExporting]: "Exporting...",
  [AnnouncementMessages.managersTitle]: "Manage access",
  [AnnouncementMessages.managersSubtitle]: "Admins allowed to create and manage notifications.",
  [AnnouncementMessages.managersEmpty]: "No users with access yet.",
  [AnnouncementMessages.managersGrantLabel]: "Grant access to an admin",
  [AnnouncementMessages.managersGrantButton]: "Grant",
  [AnnouncementMessages.managersRevoke]: "Revoke access",
  [AnnouncementMessages.managersGrantedBy]: "granted by {{name}}"
};
